import { Phone, MessageCircle, Menu } from "lucide-react";
import { HOME } from "@/constants/testIds";

const PHONE_DISPLAY = "+91 83104 76246";
const PHONE = "+918310476246";

const Navbar = () => {
    return (
        <header className="sticky top-0 z-40 w-full backdrop-blur-md bg-[#FAFAF5]/85 border-b border-[#E5E7EB]/60">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
                <a
                    href="#top"
                    data-testid={HOME.navLogo}
                    className="flex flex-col leading-tight"
                >
                    <span className="font-display text-2xl md:text-[26px] text-[#1B3B2B]">
                        Netravathi
                    </span>
                    <span className="text-[10px] md:text-[11px] uppercase tracking-[0.32em] text-[#C46A42] font-medium">
                        Tours &amp; Travels
                    </span>
                </a>
                <nav className="hidden md:flex items-center gap-8 text-sm text-[#1F2937]">
                    <a href="#packages" className="hover:text-[#1B3B2B]">
                        Packages
                    </a>
                    <a href="#services" className="hover:text-[#1B3B2B]">
                        Services
                    </a>
                    <a href="#why" className="hover:text-[#1B3B2B]">
                        Why Us
                    </a>
                    <a href="#plan" className="hover:text-[#1B3B2B]">
                        Plan a Trip
                    </a>
                </nav>
                <a
                    data-testid={HOME.navPhone}
                    href={`tel:${PHONE}`}
                    className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#1B3B2B] text-[#FAFAF5] px-4 py-2 text-sm hover:bg-[#2C5B42] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
                >
                    <Phone className="h-4 w-4" />
                    {PHONE_DISPLAY}
                </a>
                <button
                    aria-label="menu"
                    className="md:hidden text-[#1B3B2B]"
                >
                    <Menu className="h-6 w-6" />
                </button>
            </div>
        </header>
    );
};

export default Navbar;
